
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div class=\"modal dialog-success\">\n  <h2>{{#t}}Your message was sent to support{{/t}}</h2>\n  <div class=\"message\">\n    <p>{{{message}}}</p>\n  </div>\n  <button class=\"settings-button primary-button\">{{#t}}Back to Subscriptions{{/t}}</button>\n</div>\n"
      return mustache.render(src, view, partials);
    };
  